import { render, staticRenderFns } from "./seurantakeskustelut-erikoistuja.vue?vue&type=template&id=6c30e67a&scoped=true&"
import script from "./seurantakeskustelut-erikoistuja.vue?vue&type=script&lang=ts&"
export * from "./seurantakeskustelut-erikoistuja.vue?vue&type=script&lang=ts&"
import style0 from "./seurantakeskustelut-erikoistuja.vue?vue&type=style&index=0&id=6c30e67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30e67a",
  null
  
)

export default component.exports